export default [

     {
          path: '/acceptance-requirement',
          name: 'AcceptanceRequirement',
          component: () => import("@/views/Page/AcceptanceRequirement/AcceptanceRequirement.vue"),
          meta: {
               title: 'Acceptance Requirements',
          },
     }
];